import { BrandLogoEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoDeleteResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoDeleteResponseDTO.validationSchema(),
    BrandLogoEntity
  );

  constructor(readonly data: RoomBrandLogoDeleteResponse) {
    JsonSchemaValidator.assert(RoomBrandLogoDeleteResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandLogo"],
      properties: {
        roomId,
        brandLogo: {
          instanceof: BrandLogoEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandLogoDeleteResponse {
  roomId: RoomId;
  brandLogo: BrandLogoEntity;
}
